export interface AlarmEventLabels {
    speedDeviation: string[],
    routeDeviation: string[],
    stoppageAlarm: string[]
}

export enum AlarmPopupEvent {
    Close = "close"
}
export enum SpeedAlarmReasons {
    SelectReasonForSpeed = "Select reason for speed deviation",
    ChangeEtaorDestination="Change ETA and/or Destination",
    AvoidCriticalRPM = "Avoid critical RPM",
    AffectedByHeavyWeather = "Current/Weather different from forecast",
    DenseTrafficManoeuvring = "Dense Traffic and manoeuvring",
    DualSpeed = "Dual speed voyage",
    LSFollowingWeatherRoutingAdvice = "Low speed - Following weather routing advice",
    HSFollowingWeatherRoutingAdvice = "High speed - Following weather routing advice",
    ProceedingBelowMCR = "Proceeding below 10% MCR",
    PersonnelOnOff = "Personnel On/Off",
    TechnicalIssue = "Technical issue",
    VesselQueried = "Vessel queried",
    InAccurateAlarm = "Inaccurate alarm",
    Other = "Other",
}

export enum OffTrackAlarmReasons {
    SelectReasonForOfftrack = "Select reason for offtrack",
    ChangeEtaorDestination="Change ETA and/or Destination",
    AvoidHeavyWeather = "Avoid heavy weather",
    Drifting= "Drifting",
    DenseTrafficManoeuvring = "Dense Traffic and manoeuvring",
    FollowingWeatherRoutingAdvice = "Following weather routing advice",
    NavigationWarning = "Navigational Warning",
    RouteUpdatedWaypointSkipped = "Route updated/Waypoint skipped",
    VesselQueried = "Vessel queried",
    InAccurateAlarm = "Inaccurate alarm",
    Other = "Other"
}
export enum StoppageAlarmReasons {
    SelectReasonForStoppage = "Select reason for stoppage",
    ChangeEtaorDestination="Change ETA and/or Destination",
    AwaitingSafeSpeed = "Awaiting min. safe speed for ETA",
    AnchorageOrdriftingAwaiting = "Anchorage/drifting awaiting berth",
    FollowingWeatherRoutingAdvice = "Following weather routing advice",
    PersonnelOnOff = "Personnel On/Off",
    ArmedGuardsWeapons= "Armed Guards/Weapons On/Off",
    TechnicalIssue = "Technical issue",
    VesselQueried = "Vessel queried",
    InAccurateAlarm = "Inaccurate alarm",
    Other = "Other"
}

export enum SelectAlarmReason {
    SelectReasonForStoppage = "Select reason for stoppage",
    SelectReasonForSpeedDeviation = "Select reason for speed deviation",
    SelectReasonForOffTrack = "Select reason for off track"
}

export enum OtherReason {
    Other = "Other"
}